class Attribute {
    private gl: WebGLRenderingContext
    private location: number
    private size: number
    private type: number

    constructor(gl: WebGLRenderingContext, program: WebGLProgram, name: string, size: number, type: number = gl.FLOAT) {
        this.gl = gl
        this.location = gl.getAttribLocation(program, name)
        this.size = size
        this.type = type
    }

    upload(buffer: WebGLBuffer) {
        const { gl } = this

        gl.bindBuffer(gl.ARRAY_BUFFER, buffer)
        gl.enableVertexAttribArray(this.location)
        gl.vertexAttribPointer(this.location, this.size, this.type, false, 0, 0)
    }
}

export default Attribute
